import { Badge } from "@chakra-ui/react"
import { ActivityStatus } from "@hydrologiq/gql/graphql"
import { FaCheck, FaClock, FaSpinner, FaFileInvoiceDollar } from "react-icons/fa6"

export type StatusType = "scheduled" | "in_progress" | "completed" | "billed"

interface StatusBadgeProps {
  status: StatusType
}

export const mapStatusToBadge = (activityStatus: ActivityStatus): StatusType => {
  if (activityStatus === ActivityStatus.Scheduled) return "scheduled"
  if (activityStatus === ActivityStatus.Started) return "in_progress"
  if (activityStatus === ActivityStatus.Completed) return "completed"
  return "scheduled" // default
}

export const statusConfig = {
  scheduled: {
    label: "Scheduled",
    backgroundColor: "#FEEBC8",
    textColor: "primary",
    icon: FaClock,
  },
  in_progress: {
    label: "In Progress",
    backgroundColor: "#BEE3F8",
    textColor: "primary",
    icon: FaSpinner,
  },
  completed: {
    label: "Completed",
    backgroundColor: "#C6F6D5",
    textColor: "primary",
    icon: FaCheck,
  },
  billed: {
    label: "Billed",
    backgroundColor: "#E9D8FD",
    textColor: "primary",
    icon: FaFileInvoiceDollar,
  },
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusConfig[status]
  const Icon = config.icon

  return (
    <Badge
      backgroundColor={config.backgroundColor}
      color={config.textColor}
      variant="subtle"
      display="inline-flex"
      alignItems="center"
      gap={1}
    >
      <Icon style={{ width: "12px", height: "12px" }} />
      {config.label}
    </Badge>
  )
}

export default StatusBadge
